module.exports = __webpack_public_path__ + "img/canopy_logo_only.a228df95.svg";